import './index.css';
import App from 'App';
import * as React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { trackMixpanelEvent } from 'utils/utilMethods';
import { MixpanelEventName } from 'utils/constants';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        ),
      }),
    ],
  });
}

trackMixpanelEvent(MixpanelEventName.APP_SESSION_START);
// Only track session end on tab switch (visibilitychange)
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    setTimeout(() => {
      if (document.visibilityState === 'hidden') {
        trackMixpanelEvent(MixpanelEventName.APP_SESSION_END);
      }
    }, 100);
  } else if (document.visibilityState === 'visible') {
    trackMixpanelEvent(MixpanelEventName.APP_SESSION_START); // or SESSION_RESUME
  }
});

ReactDOM.render(<App />, document.getElementById('root'));
